import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
// ... imports
import Layout from "./Layout";
import Event from "./Event";
import Competition from "./Competition";
import Merch from "./merch";
import Fest_Timeline from "./Fest_Timeline";
import Sponsor from "./Sponsor";
import Footer from "./Footer";
import Maff from "./maff";
import "./SlideShow.css";
import Front from "./Front";
import Message from './Message';

function Routing() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Front />} />
          <Route path="/Events" element={<Event />} />
          <Route path="/Competitions" element={<Competition />} />{" "}
          <Route path="/Timeline" element={<Fest_Timeline />} />{" "}
          <Route path="/Merch" element={<Message />} />{" "}
          <Route path="/Sponsor" element={<Sponsor />} />
          <Route path="/Maffick" element={<Maff />} />
          <Route path="/Message" element={<Message />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Routing;
